import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stringSorter } from "../../utils/functions.js";
import DataTable from "../../components/CustomDatatable/index.js";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
} from "antd";
import {
  EditOutlined,
  HomeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Spinner } from "reactstrap";
import GlGroupForm from "./GlGroupForm.js";
import { addGlGroup, getGlGroup, updateGlGroup } from "../../store/actions/glGroup.js";

const { Title } = Typography;

const GlGroup = () => {
  document.title = "GL Group";
  const [isLoading, setIsLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const dispatch = useDispatch();
  const glGroup = useSelector((state) => state.glGroup.list);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        await dispatch(getGlGroup());
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [dispatch]);

  const handleCreate = async (values) => {
    if (selectedRecord) {
      await dispatch(updateGlGroup({ ...selectedRecord, ...values }));
    } else {
      await dispatch(addGlGroup(values));
    }
    await dispatch(getGlGroup());
    setIsModalVisible(false);
  };

  const renderCell = (text) => (text ? text : 'N/A');

  let columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: stringSorter("name"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "CODE",
      dataIndex: "code",
      key: "code",
      sorter: stringSorter("code"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Parent",
      dataIndex: "parentName",
      key: "parentName",
      sorter: stringSorter("parentName"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Group Type",
      dataIndex: "groupType",
      key: "groupType",
      sorter: stringSorter("groupType"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Ordinal Index",
      dataIndex: "ordinalIndex",
      key: "ordinalIndex",
      sorter: (a, b) => a.ordinalIndex - b.ordinalIndex,
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Logs",
      dataIndex: "logs",
      key: "logs",
      sorter: stringSorter("logs"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "User Code",
      dataIndex: "userCode",
      key: "userCode",
      sorter: stringSorter("userCode"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button>
        </Space>
      ),
    },
  ];


  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
       <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>GL Group</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Manage GL Group
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add GL Group
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={glGroup.map((item, index) => ({
                ...item,
                key: item.id,
                originalIndex: index + 1,
              }))}
              columns={columns}
            />
          )}
        </Space>
      </Card>
      <GlGroupForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
        glGroups={glGroup}
      />
    </div>
  );
};

export default GlGroup;


// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { stringSorter } from "../../utils/functions.js";
// import DataTable from "../../components/CustomDatatable/index.js";
// import {
//   Button,
//   Card,
//   Space,
//   Typography,
//   Breadcrumb,
//   Row,
//   Col,
//   Popconfirm,
//   Switch,
// } from "antd";
// import {
//   EditOutlined,
//   HomeOutlined,
//   PlusOutlined,
// } from "@ant-design/icons";
// import { Spinner } from "reactstrap";
// import GlGroupForm from "./GlGroupForm.js";
// import { enhanceColumnsWithFilters } from "../../components/ColumnFilters/index.js";
// import moment from "moment-timezone";
// import { deletePackage } from "../../store/actions/package.js";
// import { addGlGroup, deleteGlGroup, getGlGroup, updateGlGroup } from "../../store/actions/glGroup.js";

// const { Title } = Typography;

// const GlGroup = () => {
//   document.title = "GL Group";
//   const [isLoading, setIsLoading] = useState(true);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);

//   const dispatch = useDispatch();
//   const glGroup = useSelector((state) => state.glGroup.list);



//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         await dispatch(getGlGroup());
//         setIsLoading(false);
//       } catch (error) {
//         setIsLoading(false);
//       }
//     };

//     fetchProducts();
//   }, [dispatch]);

//   const handleCreate = async (values) => {
//     const formData = new FormData();
//     if (selectedRecord) {
//       formData.append('id', selectedRecord.id);
//       await dispatch(updateGlGroup({ ...selectedRecord, ...values }));
//       await dispatch(getGlGroup())
//     } else {
//       await dispatch(addGlGroup(values));
//       await dispatch(getGlGroup())
//     }
//     setIsModalVisible(false);
//   };
//   console.log("glGroup :", glGroup);
//   const handleDelete = async (id) => {
//     await dispatch(deleteGlGroup(id));
//     await dispatch(getGlGroup());
//   };

//   // const handleChangeStatus = async (id, currentStatus) => {
//   //   const newStatus = currentStatus === 1 ? 0 : 1; // Toggle status
//   //   const updatedData = { id: id, status: newStatus }; // Create an object for update
//   //   await dispatch(updateGlGroup(updatedData));
//   //   await dispatch(getGlGroup());
//   // };

//   const renderCell = (text) => (text ? text : 'N/A');
//   let columns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//       sorter: stringSorter("name"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     {
//       title: "CODE",
//       dataIndex: "code",
//       key: "code",
//       sorter: stringSorter("code"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     {
//       title: "Parent Id",
//       dataIndex: "parentId",
//       key: "parentId",
//       sorter: stringSorter("parentId"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     {
//       title: "Group Type",
//       dataIndex: "groupType",
//       key: "groupType",
//       sorter: stringSorter("groupType"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     {
//       title: "Logs",
//       dataIndex: "logs",
//       key: "logs",
//       sorter: stringSorter("logs"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     {
//       title: "User Code",
//       dataIndex: "userCode",
//       key: "userCode",
//       sorter: stringSorter("userCode"),
//       sortDirections: ["ascend", "descend"],
//       render: renderCell,
//     },
//     // {
//     //   title: "createdu",
//     //   dataIndex: "createdu",
//     //   key: "createdu",
//     //   sorter: stringSorter("createdu"),
//     //   sortDirections: ["ascend", "descend"],
//     // },
//     // {
//     //   title: "Created At",
//     //   dataIndex: "createdAt",
//     //   key: "createdAt",
//     //   render: (date) => moment(date).isValid() ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "",
//     //   sorter: (a, b) => moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
//     //     ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
//     //     : 0,
//     //   sortDirections: ["ascend", "descend"],
//     // },
//     // {
//     //   title: "Created By",
//     //   dataIndex: "createdByName",
//     //   key: "createdByName",
//     //   sorter: stringSorter("createdByName"),
//     //   sortDirections: ["ascend", "descend"],
//     //   render: renderCell,
//     // },
//     // {
//     //   title: "Updated At",
//     //   dataIndex: "updatedAt",
//     //   key: "updatedAt",
//     //   render: (date) => moment(date).isValid() ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "",
//     //   sorter: (a, b) => moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
//     //     ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
//     //     : 0,
//     //   sortDirections: ["ascend", "descend"],
//     // },
//     // {
//     //   title: "Updated By",
//     //   dataIndex: "updatedByName",
//     //   key: "updatedByName",
//     //   sorter: stringSorter("updatedByName"),
//     //   sortDirections: ["ascend", "descend"],
//     // },
//     // {
//     //   title: "Status",
//     //   dataIndex: "status",
//     //   key: "status",
//     //   render: (text, record) => (
//     //     <Switch
//     //       checked={text === 1}
//     //       onChange={() => handleChangeStatus(record.id, text)}
//     //     />
//     //   ),
//     // },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, record) => (
//         <Space size="middle">
//           <Button
//             type="link"
//             onClick={() => {
//               setSelectedRecord(record);
//               setIsModalVisible(true);
//             }}
//           >
//             <EditOutlined />
//           </Button>
//           {/* <Popconfirm
//             title="Are you sure you want to delete this record?"
//             onConfirm={() => handleDelete(record.id)}
//           >
//             <Button type="link" danger>
//               Delete
//             </Button>
//           </Popconfirm> */}
//         </Space>
//       ),
//     },
//   ];
//   columns = enhanceColumnsWithFilters(columns);

//   return (
//     <div className="page-content">
//       <Breadcrumb style={{ marginBottom: "16px" }}>
//         <Breadcrumb.Item href="/">
//           <HomeOutlined />
//         </Breadcrumb.Item>
//        <Breadcrumb.Item href="/dashboard">Dashboard</Breadcrumb.Item>
//         <Breadcrumb.Item>GL Group</Breadcrumb.Item>
//       </Breadcrumb>

//       <Card>
//         <Space direction="vertical" size="middle" style={{ width: "100%" }}>
//           <Row justify="space-between" align="middle">
//             <Col>
//               <Title level={2} style={{ margin: 0 }}>
//                 Manage GL Group
//               </Title>
//             </Col>
//             <Col>
//               <Button
//                 type="primary"
//                 icon={<PlusOutlined />}
//                 onClick={() => {
//                   setSelectedRecord(null);
//                   setIsModalVisible(true);
//                 }}
//               >
//                 Add GL Group
//               </Button>
//             </Col>
//           </Row>
//           {isLoading && glGroup.length > 0 ? (
//             <div className="d-flex justify-content-center">
//               <Spinner animation="border" variant="primary" />
//             </div>
//           ) : (
//             <DataTable
//               dataSource={glGroup.map((item, index) => ({
//                 ...item,
//                 key: item.id,
//                 originalIndex: index + 1,
//                 // status: item.status ? 1 : 0
//               }))}
//               columns={columns}
//             />
//           )}
//         </Space>
//       </Card>
//       <GlGroupForm
//         visible={isModalVisible}
//         onCreate={handleCreate}
//         onCancel={() => setIsModalVisible(false)}
//         record={selectedRecord}
//       />
//     </div>
//   );
// };

// export default GlGroup;